import store from '@/store'
import router from '@/router'
import auditStatus from '@/constants/auditStatus'
import { getIdPass } from '@/util/register/getAuditPass'
import { isTelegram } from './telegram/telegramHelper'

const redirect = {
  async redirectToIbPortal(methodsOptions = null) {
    const isCompleted = getIdPass(
      store.state.common.poiAuditStatus,
      store.state.common.ibtPoiAuditStatus,
      store.state.common.id3Pass
    )
    const isSubmitted = +store.state.common.poiAuditStatus === auditStatus.submitted

    if (!isCompleted) {
      await store.dispatch('common/actionPoiAuditStatus')
      isSubmitted ? methodsOptions.submitted() : router.push('/register')
      return
    }

    const url = process.env.NODE_ENV == 'development' ? 'http://localhost:8085/' : store.state.common.url
    if (url) {
      try {
        const userStore = store.state.common

        window.location = isTelegram()
          ? `${url}?accessToken=${userStore.accessToken}&pageResource=telegram`
          : `${url}?accessToken=${userStore.accessToken}`
      } catch (error) {
        console.log(error)
      }
    }
  },
  redirectToLogoutUrl(url = '') {
    if (isTelegram() && store.getters['telegram/getTelegramParams']) {
      // telegram
      const username =
        store.getters['telegram/getTelegramParams'].username || store.getters['telegram/getVtMarketsBot'].telegram_login
      const telegramId =
        store.getters['telegram/getTelegramParams'].telegramId || store.getters['telegram/getVtMarketsBot'].bot_id

      url = `?pageResource=telegram&telegramId=${telegramId}&username=${username}`
    }

    if (isTelegram() && store.getters['telegram/getTgOriPath']) {
      store.commit('telegram/setTgOriPath', '')
    }

    if (store.getters['telegram/getSidebarMenu']) {
      store.commit('telegram/setSidebarMenu', {})
    }

    if (store.getters['telegram/getSidebarMenuActive']) {
      store.commit('telegram/setSidebarMenuActive', '')
    }

    const tgRegister =
      store.getters['telegram/getTelegramToRouterPath'] &&
      store.getters['telegram/getTelegramToRouterPath'] === 'registerPage'

    window.location = tgRegister
      ? `${window.location.origin}/registerPage${url}`
      : `${window.location.origin}/login${url}`
  },
}

export default redirect
